<template>
<div>
    <pre>{{ items }}</pre>
</div>
</template>

<script>
import axios from '../../plugins/axios';
export default {
    data: () => ({
        loading: false,
        items: null,
    }),
    methods: {
        getCurrentEligibility() {
            this.loading = true;

            const date = new Date();

            axios.get(`/api/special-leaves/getDashboardMessage`).then((response) => {
                this.items = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.getCurrentEligibility();
    },
};
</script>
